import saga from './saga';
import router from './router';
import logger from './logger';

export default [saga, router, logger];
